import React from 'react'
import "../../styles/s_machine.css"
import Prodcard1 from '../../components/prodcards/Prodcard'
import imgBSwm from '../../img/WRAPPINGM/BoxStretchWM.png'
import imgCFwm from '../../img/WRAPPINGM/ClingFilmWM.png'
import imgPSwm from '../../img/WRAPPINGM/PSwm.jpeg'


export const WrappingM = () => {
    const des = {
        imgCFwm: ['Voltage - AC 220/50', 'Power - 300', 'Width - 420', 'Temperature - 160', 'Weight - 6.5', 'Dimension - 610 * 470* 120',
        ],
        imgBSwm: ['max wrapping - 600*600*600', 'wrapping efficiency -20-40', 'turntable speed -3-20', 'turntable diameter -h :600', 'turntable loading -50', 'requirement -220/50', 'dimension -600*4170*1800', 'weight -260', 'control system -plc',
        ],
        imgPSwm:['MAX WRAPPING SIZE-(500-1200)*(500-1200)','WRAPPING EFFICIENCY-20-40','TURNTABLE SPEED-3-12','TURNTABLE LOADING-2000','ELECTRICAL REQUIREMENT-220/50','FIL CARRIAGE-PRE-STRETCH TYPE','CONTROL SYSTEM-PLC','WEIGHT-800',
            ]


    }
    return (
        <div className='prdmain'>
            <div className='head2'>
                <h1>Wrapping Machine</h1>
            </div>
            <div className='items1'>
                <Prodcard1
                    imageSrc={imgCFwm}
                    model={"VP TW450"}
                    title="Cling Film Wrapping Machine"
                    altText="img of websit"
                    description={des.imgCFwm}
                />
                <Prodcard1
                    imageSrc={imgBSwm}
                    model={"VP BW 600(PLC BASED)"}
                    title="box stretch wrapping machine"
                    altText="img of websit"
                    description={des.imgBSwm}
                />
                <Prodcard1
                    imageSrc={imgPSwm}
                    model={"VP 2100"}
                    title="box stretch wrapping machine"
                    altText="img of websit"
                    description={des.imgPSwm}
                />

            </div>


        </div>
    )
}
